<div class="policy" *ngIf="policy">

    <h1 class="policy__title">{{ policy.title }}</h1>

    <div class="policy__divider"></div>

    <!-- PDF Viewer (PDF.js render — white pages, no toolbar) -->
    <ng-container *ngIf="isPdf; else htmlContent">
        <app-pdf-viewer [pdfUrl]="pdfUrl" />
    </ng-container>

    <!-- HTML Content -->
    <ng-template #htmlContent>
        <div class="policy__content" [innerHTML]="safeContent"></div>
    </ng-template>

</div>